/* EnovSpace Premium – interactions (vanilla, sans dépendance) */
(function () {
  if (window.__enovInit) return; window.__enovInit = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function onReady(fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }

  function reveal(root) {
    var els = (root || document).querySelectorAll('.enov [data-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function counters(root) {
    var els = (root || document).querySelectorAll('[data-count]:not([data-counted])');
    var run = function (el) {
      el.setAttribute('data-counted', '1');
      var to = parseFloat(el.getAttribute('data-count')), dec = (el.getAttribute('data-count').split('.')[1] || '').length;
      if (reduce) { el.textContent = to.toFixed(dec).replace('.', ','); return; }
      var t0 = null, d = 1400;
      var step = function (t) { if (!t0) t0 = t; var p = Math.min((t - t0) / d, 1), e = 1 - Math.pow(1 - p, 3);
        el.textContent = (to * e).toFixed(dec).replace('.', ','); if (p < 1) requestAnimationFrame(step); };
      requestAnimationFrame(step);
    };
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } }); }, { threshold: .5 });
    els.forEach(function (e) { io.observe(e); });
  }

  function spotlight(root) {
    (root || document).querySelectorAll('.enov-card').forEach(function (c) {
      c.addEventListener('pointermove', function (ev) { var r = c.getBoundingClientRect();
        c.style.setProperty('--mx', (ev.clientX - r.left) + 'px'); c.style.setProperty('--my', (ev.clientY - r.top) + 'px'); });
    });
  }

  function particles(root) {
    (root || document).querySelectorAll('canvas[data-enov-particles]').forEach(function (cv) {
      if (reduce || cv.__on) return; cv.__on = true;
      var ctx = cv.getContext('2d'), dpr = Math.min(window.devicePixelRatio || 1, 2), W, H, pts = [];
      var size = function () { W = cv.offsetWidth; H = cv.offsetHeight; cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        var n = Math.round(Math.max(9, Math.min(18, W * H / 45000))); pts = []; /* bulles avec modération */
        for (var i = 0; i < n; i++) pts.push({ x: Math.random() * W, y: Math.random() * H, vx: (Math.random() - .5) * .25, vy: -(.15 + Math.random() * .35), r: .6 + Math.random() * 1.6, a: .2 + Math.random() * .6 }); };
      size(); window.addEventListener('resize', size);
      var vis = true; if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { vis = e[0].isIntersecting; }).observe(cv);
      var loop = function () {
        if (vis) { ctx.clearRect(0, 0, W, H);
          pts.forEach(function (p) { p.x += p.vx; p.y += p.vy; if (p.y < -10) { p.y = H + 10; p.x = Math.random() * W; }
            ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, 6.283); ctx.fillStyle = 'rgba(0,255,196,' + p.a + ')'; ctx.fill(); });
          for (var i = 0; i < pts.length; i++) for (var j = i + 1; j < pts.length; j++) {
            var dx = pts[i].x - pts[j].x, dy = pts[i].y - pts[j].y, d = dx * dx + dy * dy;
            if (d < 9000) { ctx.strokeStyle = 'rgba(0,255,196,' + (0.08 * (1 - d / 9000)) + ')'; ctx.lineWidth = .6; ctx.beginPath(); ctx.moveTo(pts[i].x, pts[i].y); ctx.lineTo(pts[j].x, pts[j].y); ctx.stroke(); }
          } }
        requestAnimationFrame(loop);
      }; loop();
    });
  }

  function tilt(root) {
    if (reduce || !window.matchMedia('(pointer:fine)').matches) return;
    (root || document).querySelectorAll('[data-tilt]').forEach(function (el) {
      var host = el.closest('.enov') || el;
      host.addEventListener('pointermove', function (e) { var r = host.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        el.style.transform = 'perspective(900px) rotateY(' + (x * 10) + 'deg) rotateX(' + (-y * 10) + 'deg)'; });
      host.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  }

  function tft(root) {
    (root || document).querySelectorAll('[data-enov-tft]').forEach(function (box) {
      if (box.__on) return; box.__on = true;
      var steps = box.querySelectorAll('.enov-step'), circ = box.querySelector('.enov-gauge .v'), num = box.querySelector('[data-total]');
      var L = 2 * Math.PI * 54; if (circ) { circ.style.strokeDasharray = L; circ.style.strokeDashoffset = L; }
      var cur = -1, timer = null, shown = 0;
      /* Puissance max du modèle (70, 100, 140, 165 W) et nombres à la française (22,5) selon la langue de la page */
      var max = +box.dataset.max || 70, lang = document.documentElement.lang || 'en';
      var fmt = function (v) { return (Math.round(v * 10) / 10).toLocaleString(lang); };
      var animNum = function (to) { var from = shown, t0 = null; shown = to;
        if (reduce) { num.textContent = fmt(to); return; }
        var f = function (t) { if (!t0) t0 = t; var p = Math.min((t - t0) / 650, 1), e = 1 - Math.pow(1 - p, 3); num.textContent = p < 1 ? Math.round(from + (to - from) * e) : fmt(to); if (p < 1) requestAnimationFrame(f); }; requestAnimationFrame(f); };
      var set = function (i) {
        if (i === cur) return; cur = i;
        steps.forEach(function (s, k) { s.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
        var d = steps[i].dataset, vals = { c1: +d.c1 || 0, c2: +d.c2 || 0, c3: +d.c3 || 0, a: +d.a || 0 }, total = vals.c1 + vals.c2 + vals.c3 + vals.a;
        ['c1', 'c2', 'c3', 'a'].forEach(function (k) { var row = box.querySelector('[data-port="' + k + '"]'); if (!row) return;
          row.classList.toggle('off', !vals[k]); row.querySelector('u').style.width = Math.min(vals[k] / max * 100, 100) + '%';
          row.querySelector('[data-w]').textContent = vals[k] ? (d[k + 'l'] || (fmt(vals[k]) + ' W')) : '—'; });
        if (circ) circ.style.strokeDashoffset = L * (1 - Math.min(total / max, 1));
        animNum(total);
      };
      steps.forEach(function (s, k) { s.addEventListener('click', function () { set(k); restart(); }); });
      var restart = function () { clearInterval(timer); if (!reduce) timer = setInterval(function () { set((cur + 1) % steps.length); }, 2400); };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (e) { if (e[0].isIntersecting) { if (cur < 0) set(0); restart(); } else clearInterval(timer); }, { threshold: .3 }).observe(box);
      } else { set(0); }
    });
  }

  function offer(root) {
    (root || document).querySelectorAll('[data-enov-offer]').forEach(function (box) {
      if (box.__on) return; box.__on = true;
      var main = box.querySelector('.enov-offer__media img');
      box.querySelectorAll('[data-thumb]').forEach(function (b) {
        b.addEventListener('click', function () { main.style.opacity = 0; setTimeout(function () { main.src = b.dataset.thumb; main.srcset = ''; main.style.opacity = 1; }, 180);
          box.querySelectorAll('[data-thumb]').forEach(function (x) { x.setAttribute('aria-current', x === b ? 'true' : 'false'); }); });
      });
      var q = box.querySelector('input[name="quantity"]');
      box.querySelectorAll('[data-q]').forEach(function (b) { b.addEventListener('click', function () { q.value = Math.max(1, (+q.value || 1) + (+b.dataset.q)); }); });
      var form = box.querySelector('form[action*="/cart/add"]'), msg = box.querySelector('.enov-msg');
      if (form && window.fetch) form.addEventListener('submit', function (ev) {
        ev.preventDefault(); var btn = form.querySelector('[type="submit"]'); btn.disabled = true;
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
          .then(function (r) { return r.json(); })
          .then(function (j) { btn.disabled = false; if (j.status) { msg.textContent = j.description || j.message; return; }
            msg.textContent = box.dataset.added || '✓';
            window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; })
          .catch(function () { btn.disabled = false; form.submit(); });
      });
    });
  }

  function eta(root) {
    (root || document).querySelectorAll('[data-eta]').forEach(function (el) {
      var p = el.dataset.eta.split('-'), min = +p[0] || 6, max = +p[1] || 10, loc = el.dataset.loc || document.documentElement.lang || 'fr';
      var add = function (n) { var d = new Date(), c = 0; while (c < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) c++; } return d; };
      var f = function (d) { try { return d.toLocaleDateString(loc, { weekday: 'short', day: 'numeric', month: 'short' }); } catch (e) { return d.toDateString(); } };
      var out = el.querySelector('[data-eta-out]'); if (out) out.textContent = f(add(min)) + ' – ' + f(add(max));
    });
  }

  function sticky() {
    var bar = document.querySelector('[data-enov-sticky]'); if (!bar || bar.__on) return; bar.__on = true;
    var target = document.querySelector('.product-form__submit') || document.querySelector('product-form');
    if (!target || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (e) { bar.classList.toggle('is-on', !e[0].isIntersecting && e[0].boundingClientRect.top < 0); }).observe(target);
    bar.querySelector('button').addEventListener('click', function () {
      var b = document.querySelector('.product-form__submit'); if (b) { b.scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(function () { b.click(); }, 450); }
    });
  }

  function init(root) { reveal(root); counters(root); spotlight(root); particles(root); tilt(root); tft(root); offer(root); eta(root); sticky(); }
  onReady(function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
